export const PORTUGAL_CONTEXT_CODE = 'PORTUGAL';
export const PORTUGAL_PRODUCT_CODE = 'a_portugal';

export const PORTUGAL_SALES_ENABLED = true;
export const PORTUGAL_DISCOUNT_ENABLED = true;
export const PORTUGAL_REGISTRATION_FEE_OFF_ENABLED = true;
export const PORTUGAL_DISCOUNT_COUPON_ID = 'zRhhG9Qf';
export const PORTUGAL_PLAN_METRICS_VISIBLE = false;

export function normalizeContextCode(code?: string | null) {
  return (code || '').trim().toUpperCase();
}

export function isPortugalContextCode(code?: string | null) {
  return normalizeContextCode(code) === PORTUGAL_CONTEXT_CODE;
}

export function isPortugalProduct(product?: { code?: string | null } | null) {
  const code = (product?.code || '').trim();
  const subtype = ((product as any)?.subtype || '').trim().toLowerCase();
  const names = [(product as any)?.name?.es, (product as any)?.name?.en, (product as any)?.name?.pt, (product as any)?.name]
    .filter(Boolean)
    .map((value) => String(value).trim().toLowerCase());

  return code === PORTUGAL_PRODUCT_CODE || subtype.includes('portugal') || names.some((value) => value.includes('portugal'));
}

export function getPortugalAvailableUiLanguages(isPortugalContext: boolean) {
  return isPortugalContext ? ['es', 'en', 'pt'] : ['es', 'en'];
}
